module.exports = __webpack_public_path__ + "img/donante-imef.a851ed81.png";